import { useTranslation } from "react-i18next"
import type { ReactNode } from "react"

import type { StaticPlotDef, RecordType, QueryPlotDef } from "types/dashboard.types"

import Message from "widgets/common/Message"
import Plot from "widgets/plots/Plot"

interface OrgPieChartProps {
  def: StaticPlotDef | QueryPlotDef
  data: RecordType[]
  isError: boolean
  subtitle?: ReactNode
}

const OrgPieChart = ({ def, data, isError, subtitle }: OrgPieChartProps) => {
  const { t } = useTranslation()

  return (
    <>
      {isError ? (
        <Message
          messageKey={"error.FETCHING_ITEM"}
          messageOptions={{ item: t("alerts.CHART") }}
          type="error"
        />
      ) : (
        <Plot def={def} data={data} subtitle={subtitle} />
      )}
    </>
  )
}

export default OrgPieChart
